export default __webpack_public_path__ + "static/2-691e49fa886a3ac5e7f0e5a71ccc364f.png";